import React, { useState } from 'react';
import { Modal, Box, Typography, TextField, Button, Stack, MenuItem, IconButton, CircularProgress } from '@mui/material';
import { Close, PersonAdd, Email } from '@mui/icons-material';
import axios from 'axios';
import { toast } from 'react-toastify';

const AddParticipantModal = ({ open, handleClose, workshop, refreshData }) => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [sessionId, setSessionId] = useState('');

  const handleSubmit = async () => {
    if (!email || !sessionId) return toast.warning("Veuillez remplir tous les champs");
    
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      // Ton URL : /atelier/a/participant/add/{idWss}/{emailClient}
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/admin/atelier/a/participant/add/${sessionId}/${email}`,
        {}, 
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success(res.data.message || "Participant ajouté !");
      refreshData(); // Rafraîchir la liste des inscrits sur la page de détails
      handleClose();
      setEmail('');
      setSessionId('');
    } catch (err) {
      const msg = err.response?.data?.message || "Erreur lors de l'ajout";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={handleClose} closeAfterTransition>
      <Box sx={{
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 450, bgcolor: '#fff', borderRadius: '30px', p: 4, boxShadow: '0 20px 60px rgba(0,0,0,0.1)'
      }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="h6" fontWeight="800" color="#1B254B">Inscription Manuelle</Typography>
          <IconButton onClick={handleClose} size="small"><Close /></IconButton>
        </Stack>

        <Stack spacing={3}>
          <Typography variant="body2" color="#A3AED0">
            Choisissez une session et saisissez l'adresse email du client déjà inscrit sur la plateforme.
          </Typography>

          {/* SÉLECTION DE LA SESSION */}
          <TextField
            select
            fullWidth
            label="Session de l'atelier"
            value={sessionId}
            onChange={(e) => setSessionId(e.target.value)}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
          >
            {workshop.sessions?.map((s) => (
              <MenuItem key={s.id_wss} value={s.id_wss} disabled={s.participant_count_wss >= s.capacity}>
                {new Date(s.date_wss).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })} à {new Date(s.date_wss).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })} 
                {` (${s.participant_count_wss}/${s.capacity} inscrits)`}
              </MenuItem>
            ))}
          </TextField>

          {/* EMAIL DU CLIENT */}
          <TextField
            fullWidth
            label="Email du client"
            placeholder="exemple@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            InputProps={{ startAdornment: <Email sx={{ color: '#A3AED0', mr: 1, fontSize: 20 }} /> }}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
          />

          <Button
            fullWidth
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <PersonAdd />}
            sx={{ 
              bgcolor: '#4318FF', borderRadius: '12px', py: 1.5, fontWeight: '700',
              textTransform: 'none', fontSize: '16px', boxShadow: '0 10px 20px rgba(67, 24, 255, 0.2)'
            }}
          >
            {loading ? 'Traitement...' : 'Confirmer l\'inscription'}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default AddParticipantModal;
